import api from '../mixins/apiService'

const getMyChat = type => api.get('/message', { type })

const getMessage = (productId, clientId) => api.get(`/message/${productId}/${clientId}`)

const postMessage = ({ productId, ownerId, clientId, message }) => api.post('/message', { productId, ownerId, clientId, message })

export default { getMyChat, getMessage, postMessage }
